import _toConsumableArray from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "manage-header"
};
var _hoisted_2 = {
  "class": "manage-header-content"
};
var _hoisted_3 = {
  key: 1,
  "class": "main"
};
var _hoisted_4 = {
  "class": "userInfo space-top"
};
var _hoisted_5 = {
  "class": "userInfo-header-left"
};
var _hoisted_6 = {
  "class": "userInfo-header-right"
};
var _hoisted_7 = {
  "class": "span"
};
var _hoisted_8 = {
  "class": "userInfo-list"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  "class": "userInfo-list-item-info"
};
var _hoisted_12 = {
  key: 0,
  "class": "userInfo-list-item"
};
var _hoisted_13 = {
  key: 1,
  "class": "userInfo-list-item"
};
var _hoisted_14 = {
  "class": "aside"
};
var _hoisted_15 = {
  "class": "label"
};
var _hoisted_16 = {
  "class": "article"
};
var _hoisted_17 = {
  "class": "label"
};
var _hoisted_18 = {
  "class": "list-item"
};
var _hoisted_19 = {
  "class": "label"
};
var _hoisted_20 = {
  "class": "groupID"
};
var _hoisted_21 = {
  "class": "span"
};
var _hoisted_22 = {
  "class": "list-item"
};
var _hoisted_23 = {
  "class": "label"
};
var _hoisted_24 = ["src"];
var _hoisted_25 = {
  "class": "list-item"
};
var _hoisted_26 = {
  "class": "label"
};
var _hoisted_27 = {
  "class": "span"
};
var _hoisted_28 = {
  "class": "list-item"
};
var _hoisted_29 = {
  "class": "label"
};
var _hoisted_30 = {
  "class": "span"
};
var _hoisted_31 = {
  "class": "footer list space-top"
};
var _hoisted_32 = {
  key: 0,
  "class": "delDialog-title"
};
var _hoisted_33 = {
  key: 1,
  "class": "delDialog-title"
};
import TUIChatEngine, { TUITranslateService, TUIGroupService, TUIFriendService, TUIStore, StoreName, TUIConversationService } from "@tencentcloud/chat-uikit-engine";
import { ref, computed, watchEffect, onMounted, onBeforeUnmount, nextTick } from "../../../adapter-vue";
import MaskLayer from "../../common/MaskLayer/index.vue";
import Dialog from "../../common/Dialog/index.vue";
import Transfer from "../../common/Transfer/index.vue";
import ManageName from "./manage-name.vue";
import ManageNotification from "./manage-notification.vue";
import ManageMember from "./manage-member.vue";
import ManageProfile from "./manage-profile.vue";
import ManageAdmin from "./manage-admin.vue";
import Icon from "../../common/Icon.vue";
import backSVG from "../../../assets/icon/back.svg";
import rightIcon from "../../../assets/icon/right-icon.svg";
import { Toast, TOAST_TYPE } from "../../common/Toast/index";
import { isPC, isUniFrameWork } from "../../../utils/env";
import { TUIGlobal } from "../../../utils/universal-api/index";
import Server from "../server";
import { enableSampleTaskStatus } from "../../../utils/enableSampleTaskStatus";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    groupID: {
      type: String,
      "default": ""
    },
    groupCurrentTab: {
      type: String,
      "default": ""
    }
  },
  setup: function setup(__props) {
    var TUIGroupServer = Server.getInstance();
    var TUIConstants = TUIGroupServer.constants;
    var props = __props;
    var manageRef = ref(undefined);
    var currentTab = ref("");
    var editLableName = ref("");
    var transferType = ref("");
    var mask = ref(false);
    var currentGroupID = ref("");
    var userInfo = ref({
      list: []
    });
    var currentMember = ref({});
    var typeName = ref(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, TUIChatEngine.TYPES.GRP_WORK, "好友工作群"), TUIChatEngine.TYPES.GRP_PUBLIC, "陌生人社交群"), TUIChatEngine.TYPES.GRP_MEETING, "临时会议群"), TUIChatEngine.TYPES.GRP_AVCHATROOM, "直播群"), TUIChatEngine.TYPES.GRP_COMMUNITY, "社群"), TUIChatEngine.TYPES.JOIN_OPTIONS_FREE_ACCESS, "自由加入"), TUIChatEngine.TYPES.JOIN_OPTIONS_NEED_PERMISSION, "需要验证"), TUIChatEngine.TYPES.JOIN_OPTIONS_DISABLE_APPLY, "禁止加群"));
    var member = ref({
      admin: [],
      member: [],
      muteMember: []
    });
    var transferList = ref([]);
    var transferTitle = ref("");
    var isSearch = ref(false);
    var isRadio = ref(false);
    var selectedList = ref([]);
    var delDialogShow = ref(false);
    var groupMemberList = ref([]);
    var deletedUserList = ref([]);
    var _currentGroup = ref();
    var currentSelfRole = ref("");
    var groupID = ref("");
    var isClickSelf = ref(false);
    var handleClick = function handleClick(event) {
      var e = event || window.event;
      var target = e.target || e.srcElement;
      if (!(target == manageRef.value) && !manageRef.value.contains(target) && !isClickSelf.value) {
        // 目标元素外
        handleCompleteManage();
      }
      isClickSelf.value = false;
    };
    var handleTargetClick = function handleTargetClick() {
      isClickSelf.value = true;
    };
    var onClickOutside = function onClickOutside() {
      if (document && !isUniFrameWork) {
        document.addEventListener('click', handleClick);
        manageRef.value.addEventListener("click", handleTargetClick);
      }
    };
    var offClickOutside = function offClickOutside() {
      if (document && !isUniFrameWork) {
        document.removeEventListener('click', handleClick);
        manageRef.value.removeEventListener("click", handleTargetClick);
      }
    };
    onMounted(function () {
      nextTick(function () {
        manageRef.value && onClickOutside();
      });
    });
    onBeforeUnmount(function () {
      offClickOutside();
    });
    TUIStore.watch(StoreName.GRP, {
      currentGroup: function currentGroup(group) {
        if (group) {
          var _currentGroup$value;
          _currentGroup.value = group;
          currentSelfRole.value = (_currentGroup$value = _currentGroup.value) === null || _currentGroup$value === void 0 || (_currentGroup$value = _currentGroup$value.selfInfo) === null || _currentGroup$value === void 0 ? void 0 : _currentGroup$value.role;
        }
      },
      currentGroupMemberList: function currentGroupMemberList(memberList) {
        groupMemberList.value = memberList;
        member.value = {
          admin: [],
          member: [],
          muteMember: []
        };
        Array.from(memberList).map(function (item) {
          switch (item === null || item === void 0 ? void 0 : item.role) {
            case TUIChatEngine.TYPES.GRP_MBR_ROLE_ADMIN:
              member.value.admin.push(item);
              break;
            case TUIChatEngine.TYPES.GRP_MBR_ROLE_MEMBER:
              member.value.member.push(item);
              break;
            default:
              break;
          }
          return item;
        });
        var time = new Date().getTime();
        member.value.muteMember = Array.from(memberList).filter(function (item) {
          return (item === null || item === void 0 ? void 0 : item.muteUntil) * 1000 - time > 0;
        });
      }
    });
    TUIStore.watch(StoreName.CONV, {
      currentConversation: function currentConversation(conversation) {
        var _conversation$groupPr;
        groupID.value = conversation === null || conversation === void 0 || (_conversation$groupPr = conversation.groupProfile) === null || _conversation$groupPr === void 0 ? void 0 : _conversation$groupPr.groupID;
      }
    });
    watchEffect(function () {
      var params = TUIGroupServer.getOnCallParams(TUIConstants.TUIGroup.SERVICE.METHOD.OPEN_GROUP_MANAGEMENT);
      currentGroupID.value = params.groupID || groupID.value;
      currentTab.value = props.groupCurrentTab;
    });
    var TabName = computed(function () {
      var name = "";
      switch (currentTab.value) {
        case "notification":
          name = "群公告";
          break;
        case "member":
          name = "群成员";
          break;
        case "profile":
          name = "群成员";
          break;
        default:
          name = "群管理";
          break;
      }
      return name;
    });
    var isAuthor = computed(function () {
      var _currentGroup$value2;
      // 判断是否是群主/管理员
      var userRole = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value2 = _currentGroup.value) === null || _currentGroup$value2 === void 0 || (_currentGroup$value2 = _currentGroup$value2.selfInfo) === null || _currentGroup$value2 === void 0 ? void 0 : _currentGroup$value2.role;
      var isOwner = userRole === TUIChatEngine.TYPES.GRP_MBR_ROLE_OWNER;
      var isAdmin = userRole === TUIChatEngine.TYPES.GRP_MBR_ROLE_ADMIN;
      return isOwner || isAdmin;
    });
    var isAdmin = computed(function () {
      var _currentGroup$value3, _currentGroup$value4;
      var groupType = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value3 = _currentGroup.value) === null || _currentGroup$value3 === void 0 ? void 0 : _currentGroup$value3.type;
      var userRole = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value4 = _currentGroup.value) === null || _currentGroup$value4 === void 0 || (_currentGroup$value4 = _currentGroup$value4.selfInfo) === null || _currentGroup$value4 === void 0 ? void 0 : _currentGroup$value4.role;
      var isOwner = userRole === TUIChatEngine.TYPES.GRP_MBR_ROLE_OWNER;
      var isWork = groupType === TUIChatEngine.TYPES.GRP_WORK;
      var isAVChatRoom = groupType === TUIChatEngine.TYPES.GRP_AVCHATROOM;
      if (!isWork && !isAVChatRoom && isOwner) {
        return true;
      }
      return false;
    });
    var isSetMuteTime = computed(function () {
      var _currentGroup$value5;
      var groupType = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value5 = _currentGroup.value) === null || _currentGroup$value5 === void 0 ? void 0 : _currentGroup$value5.type;
      var isWork = groupType === TUIChatEngine.TYPES.GRP_WORK;
      if (isWork || !isAuthor.value) {
        return false;
      }
      return true;
    });
    var canDelMember = computed(function () {
      var _currentGroup$value6;
      var groupType = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value6 = _currentGroup.value) === null || _currentGroup$value6 === void 0 ? void 0 : _currentGroup$value6.type;
      var isAVChatRoom = groupType === TUIChatEngine.TYPES.GRP_AVCHATROOM;
      if (isAVChatRoom) {
        return false;
      }
      return true;
    });
    var updateProfile = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(newGroupProfile) {
        var key, value, options;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              key = newGroupProfile.key, value = newGroupProfile.value;
              options = _defineProperty({
                groupID: _currentGroup.value.groupID
              }, key, value);
              TUIGroupService.updateGroupProfile(options).then(function (res) {
                _currentGroup.value = res.data.group;
                editLableName.value = "";
              })["catch"](function (error) {
                Toast({
                  message: error === null || error === void 0 ? void 0 : error.message,
                  type: TOAST_TYPE.ERROR
                });
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function updateProfile(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var setCurrentTab = function setCurrentTab(tabName) {
      currentTab.value = tabName;
      editLableName.value = "";
      if (currentTab.value === "member") {
        transferType.value = "remove";
      }
      if (!currentTab.value) {
        transferType.value = "";
      }
    };
    var cancel = function cancel() {
      toggleMask();
    };
    var toggleMask = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(type) {
        var _transferList$value;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              selectedList.value = [];
              _context2.t0 = type;
              _context2.next = _context2.t0 === "add" ? 4 : _context2.t0 === "remove" ? 10 : _context2.t0 === "addAdmin" ? 14 : _context2.t0 === "removeAdmin" ? 18 : _context2.t0 === "changeOwner" ? 22 : _context2.t0 === "addMute" ? 26 : _context2.t0 === "removeMute" ? 32 : 36;
              break;
            case 4:
              isRadio.value = false;
              _context2.next = 7;
              return friendList();
            case 7:
              transferList.value = _context2.sent;
              transferTitle.value = "添加成员";
              return _context2.abrupt("break", 37);
            case 10:
              isRadio.value = false;
              transferList.value = groupMemberList.value.filter(function (item) {
                var _currentGroup$value7;
                return item.userID !== (_currentGroup === null || _currentGroup === void 0 || (_currentGroup$value7 = _currentGroup.value) === null || _currentGroup$value7 === void 0 || (_currentGroup$value7 = _currentGroup$value7.selfInfo) === null || _currentGroup$value7 === void 0 ? void 0 : _currentGroup$value7.userID);
              });
              transferTitle.value = "删除成员";
              return _context2.abrupt("break", 37);
            case 14:
              isRadio.value = true;
              transferList.value = member.value.member;
              transferTitle.value = "新增管理员";
              return _context2.abrupt("break", 37);
            case 18:
              isRadio.value = true;
              transferList.value = member.value.admin;
              transferTitle.value = "移除管理员";
              return _context2.abrupt("break", 37);
            case 22:
              isRadio.value = true;
              transferList.value = [].concat(_toConsumableArray(member.value.admin), _toConsumableArray(member.value.member));
              transferTitle.value = "转让群组";
              return _context2.abrupt("break", 37);
            case 26:
              isRadio.value = true;
              transferList.value = member.value.member;
              if (_currentGroup.value.selfInfo.role === "Owner") {
                transferList.value = [].concat(_toConsumableArray(member.value.admin), _toConsumableArray(member.value.member));
              }
              transferList.value = transferList === null || transferList === void 0 || (_transferList$value = transferList.value) === null || _transferList$value === void 0 ? void 0 : _transferList$value.filter(function (item) {
                var _member$value;
                return (member === null || member === void 0 || (_member$value = member.value) === null || _member$value === void 0 || (_member$value = _member$value.muteMember) === null || _member$value === void 0 ? void 0 : _member$value.indexOf(item)) < 0;
              });
              transferTitle.value = "新增禁言用户";
              return _context2.abrupt("break", 37);
            case 32:
              isRadio.value = true;
              transferList.value = member.value.muteMember;
              transferTitle.value = "移除禁言用户";
              return _context2.abrupt("break", 37);
            case 36:
              return _context2.abrupt("break", 37);
            case 37:
              type && (transferType.value = type);
              mask.value = !mask.value;
            case 39:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function toggleMask(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    var friendList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var imResponse, friendList;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return TUIFriendService.getFriendList();
            case 2:
              imResponse = _context3.sent;
              friendList = imResponse.data.map(function (item) {
                return item === null || item === void 0 ? void 0 : item.profile;
              });
              return _context3.abrupt("return", friendList.filter(function (item) {
                return !userInfo.value.list.some(function (infoItem) {
                  return infoItem.userID === item.userID;
                });
              }));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function friendList() {
        return _ref4.apply(this, arguments);
      };
    }();
    var canIDissmissGroup = computed(function () {
      var _currentGroup$value8, _currentGroup$value9;
      var userRole = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value8 = _currentGroup.value) === null || _currentGroup$value8 === void 0 || (_currentGroup$value8 = _currentGroup$value8.selfInfo) === null || _currentGroup$value8 === void 0 ? void 0 : _currentGroup$value8.role;
      var groupType = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value9 = _currentGroup.value) === null || _currentGroup$value9 === void 0 ? void 0 : _currentGroup$value9.type;
      return userRole === TUIChatEngine.TYPES.GRP_MBR_ROLE_OWNER && groupType !== TUIChatEngine.TYPES.GRP_WORK;
    });
    var isShowAddMember = computed(function () {
      var _currentGroup$value10;
      var groupType = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value10 = _currentGroup.value) === null || _currentGroup$value10 === void 0 ? void 0 : _currentGroup$value10.type;
      return groupType === TUIChatEngine.TYPES.GRP_WORK;
    });
    var showUserNum = computed(function () {
      var _currentGroup$value11;
      var num = 3;
      if (!isShowAddMember.value) {
        num += 1;
      }
      if ((_currentGroup === null || _currentGroup === void 0 || (_currentGroup$value11 = _currentGroup.value) === null || _currentGroup$value11 === void 0 || (_currentGroup$value11 = _currentGroup$value11.selfInfo) === null || _currentGroup$value11 === void 0 ? void 0 : _currentGroup$value11.role) !== "Owner") {
        num += 1;
      }
      return num;
    });
    var getMember = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(type) {
        var groupID, options;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              groupID = currentGroupID.value;
              options = {
                groupID: groupID,
                count: 100,
                offset: type && type === "more" ? userInfo.value.list.length : 0
              };
              _context4.next = 4;
              return TUIGroupService.getGroupMemberList(options).then(function (res) {
                if (type && type === "more") {
                  userInfo.value.list = [].concat(_toConsumableArray(userInfo.value.list), _toConsumableArray(res.data.memberList));
                } else {
                  userInfo.value.list = res.data.memberList;
                }
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function getMember(_x3) {
        return _ref5.apply(this, arguments);
      };
    }();
    var handleMemberProfileShow = function handleMemberProfileShow(user) {
      currentMember.value = user;
      setCurrentTab("profile");
    };
    var submit = function submit(userList) {
      // 进行成员移除等等相关操作
      if (transferType.value === "remove") {
        deletedUserList.value = userList;
        delDialogShow.value = !delDialogShow.value;
      } else {
        handleManage(userList, transferType.value);
      }
      mask.value = false;
    };
    var handleGroupIDCopy = function handleGroupIDCopy() {
      // 复制群id 这里暂时不做处理。之前使用的 vue-clipboard3 在其他平台不适用
    };
    var dismissGroup = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(group) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return TUIGroupService.dismissGroup(group.groupID);
            case 2:
              enableSampleTaskStatus("dismissGroup");
              Toast({
                message: TUITranslateService.t("TUIGroup.群组解散成功"),
                type: TOAST_TYPE.SUCCESS
              });
              clearGroupInfo();
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function dismissGroup(_x4) {
        return _ref6.apply(this, arguments);
      };
    }();
    var clearGroupInfo = function clearGroupInfo() {
      if (isUniFrameWork) {
        TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.switchTab({
          url: "/TUIKit/components/TUIConversation/index"
        });
      } else {
        handleCompleteManage();
        // 回到chat default 页
        TUIConversationService.switchConversation();
      }
    };
    var setAllMuteTime = function setAllMuteTime(value) {
      // 设置全体禁言时间
      updateProfile({
        key: "muteAllMembers",
        value: value
      });
      if (value) {
        enableSampleTaskStatus("muteGroup");
        Toast({
          message: TUITranslateService.t("TUIGroup.禁言设置成功"),
          type: TOAST_TYPE.SUCCESS
        });
      } else {
        Toast({
          message: TUITranslateService.t("TUIGroup.取消禁言成功"),
          type: TOAST_TYPE.SUCCESS
        });
      }
    };
    var handleSearchMember = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(value) {
        var imResponse, imMemberResponse, options, _imMemberResponse, message, _imResponse2, _message, _message2;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              imResponse = {};
              imMemberResponse = {};
              options = {
                groupID: currentGroupID.value,
                userIDList: [value]
              };
              _context6.t0 = transferType.value;
              _context6.next = _context6.t0 === "add" ? 6 : _context6.t0 === "remove" ? 20 : 34;
              break;
            case 6:
              _context6.prev = 6;
              _context6.next = 9;
              return TUIGroupService.getGroupMemberProfile(options);
            case 9:
              imMemberResponse = _context6.sent;
              transferList.value = transferList.value.filter(function (item) {
                var _imResponse$data$;
                return item.userID !== ((_imResponse$data$ = imResponse.data[0]) === null || _imResponse$data$ === void 0 ? void 0 : _imResponse$data$.userID);
              });
              transferList.value = [].concat(_toConsumableArray(transferList.value), _toConsumableArray(imResponse.data));
              if (((_imMemberResponse = imMemberResponse) === null || _imMemberResponse === void 0 || (_imMemberResponse = _imMemberResponse.data) === null || _imMemberResponse === void 0 ? void 0 : _imMemberResponse.memberList.length) > 0) {
                transferList.value = transferList.value.map(function (item) {
                  var _imMemberResponse2;
                  if (item.userID === ((_imMemberResponse2 = imMemberResponse) === null || _imMemberResponse2 === void 0 || (_imMemberResponse2 = _imMemberResponse2.data) === null || _imMemberResponse2 === void 0 ? void 0 : _imMemberResponse2.memberList[0].userID)) {
                    item.isDisabled = true;
                  }
                  return item;
                });
              }
              _context6.next = 19;
              break;
            case 15:
              _context6.prev = 15;
              _context6.t1 = _context6["catch"](6);
              message = TUITranslateService.t("TUIGroup.该用户不存在");
              Toast({
                message: message,
                type: TOAST_TYPE.ERROR
              });
            case 19:
              return _context6.abrupt("break", 35);
            case 20:
              _context6.prev = 20;
              _context6.next = 23;
              return TUIGroupService.getGroupMemberProfile(options);
            case 23:
              imResponse = _context6.sent;
              if (imResponse.data.memberList.length === 0) {
                _message = TUITranslateService.t("TUIGroup.该用户不在群组内");
                Toast({
                  message: _message,
                  type: TOAST_TYPE.ERROR
                });
              }
              transferList.value = transferList.value.filter(function (item) {
                var _imResponse;
                return item.userID !== ((_imResponse = imResponse) === null || _imResponse === void 0 || (_imResponse = _imResponse.data) === null || _imResponse === void 0 || (_imResponse = _imResponse.memberList[0]) === null || _imResponse === void 0 ? void 0 : _imResponse.userID);
              });
              transferList.value = [].concat(_toConsumableArray(transferList.value), _toConsumableArray((_imResponse2 = imResponse) === null || _imResponse2 === void 0 || (_imResponse2 = _imResponse2.data) === null || _imResponse2 === void 0 ? void 0 : _imResponse2.memberList));
              _context6.next = 33;
              break;
            case 29:
              _context6.prev = 29;
              _context6.t2 = _context6["catch"](20);
              _message2 = TUITranslateService.t("TUIGroup.该用户不存在");
              Toast({
                message: _message2,
                type: TOAST_TYPE.ERROR
              });
            case 33:
              return _context6.abrupt("break", 35);
            case 34:
              return _context6.abrupt("break", 35);
            case 35:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[6, 15], [20, 29]]);
      }));
      return function handleSearchMember(_x5) {
        return _ref7.apply(this, arguments);
      };
    }();
    var handleManage = function handleManage(userList, type) {
      var userIDList = [];
      userList.map(function (item) {
        userIDList.push(item.userID);
        return item;
      });
      switch (type) {
        case "add":
          addMember(userIDList);
          break;
        case "remove":
          deleteGroupMember(userIDList);
          break;
        case "addAdmin":
          handleAdmin(userList[0]);
          break;
        case "removeAdmin":
          handleAdmin(userList[0]);
          break;
        case "changeOwner":
          changeOwner(userIDList[0]);
          break;
        case "addMute":
          setMemberMuteTime(userIDList[0], "add");
          break;
        case "removeMute":
          setMemberMuteTime(userIDList[0], "remove");
          break;
        default:
          break;
      }
    };
    var addMember = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(userIDList) {
        var options;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              options = {
                groupID: currentGroupID.value,
                userIDList: userIDList
              };
              _context7.next = 3;
              return TUIGroupService.addGroupMember(options);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function addMember(_x6) {
        return _ref8.apply(this, arguments);
      };
    }();
    var changeOwner = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(userID) {
        var options, imResponse;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              options = {
                groupID: currentGroupID.value,
                newOwnerID: userID
              };
              _context8.next = 3;
              return TUIGroupService.changeGroupOwner(options);
            case 3:
              imResponse = _context8.sent;
              _currentGroup.value = {};
              _currentGroup.value = imResponse.data.group;
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function changeOwner(_x7) {
        return _ref9.apply(this, arguments);
      };
    }();
    var setMemberMuteTime = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(userID, type) {
        var options;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              options = {
                groupID: currentGroupID.value,
                userID: userID,
                muteTime: type === "add" ? 60 * 60 * 24 * 30 : 0
              };
              _context9.next = 3;
              return TUIGroupService.setGroupMemberMuteTime(options);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return function setMemberMuteTime(_x8, _x9) {
        return _ref10.apply(this, arguments);
      };
    }();
    var handleAdmin = /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(user) {
        var role, options;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              role = "";
              _context10.t0 = user.role;
              _context10.next = _context10.t0 === TUIChatEngine.TYPES.GRP_MBR_ROLE_ADMIN ? 4 : _context10.t0 === TUIChatEngine.TYPES.GRP_MBR_ROLE_MEMBER ? 6 : 8;
              break;
            case 4:
              role = TUIChatEngine.TYPES.GRP_MBR_ROLE_MEMBER;
              return _context10.abrupt("break", 8);
            case 6:
              role = TUIChatEngine.TYPES.GRP_MBR_ROLE_ADMIN;
              return _context10.abrupt("break", 8);
            case 8:
              options = {
                groupID: currentGroupID.value,
                userID: user.userID,
                role: role
              };
              _context10.next = 11;
              return TUIGroupService.setGroupMemberRole(options);
            case 11:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      return function handleAdmin(_x10) {
        return _ref11.apply(this, arguments);
      };
    }();
    var deleteGroupMember = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(userIDList) {
        var options;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              options = {
                groupID: currentGroupID.value,
                userIDList: userIDList,
                reason: ""
              };
              _context11.next = 3;
              return TUIGroupService.deleteGroupMember(options);
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      return function deleteGroupMember(_x11) {
        return _ref12.apply(this, arguments);
      };
    }();
    var quitGroup = /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(group) {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return TUIGroupService.quitGroup(group.groupID);
            case 2:
              clearGroupInfo();
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      return function quitGroup(_x12) {
        return _ref13.apply(this, arguments);
      };
    }();
    var back = function back() {
      if (currentTab.value) {
        setCurrentTab("");
      } else {
        handleCompleteManage();
      }
    };
    var handleCompleteManage = function handleCompleteManage() {
      TUIStore.update(StoreName.GRP, "isShowManageComponent", false);
      var callback = TUIGroupServer.getOnCallCallback(TUIConstants.TUIGroup.SERVICE.METHOD.OPEN_GROUP_MANAGEMENT);
      callback && callback();
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": "manage",
        ref_key: "manageRef",
        ref: manageRef
      }, [!_unref(isUniFrameWork) || _unref(currentTab) === 'admin' ? (_openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("div", {
        onClick: back
      }, [_createVNode(Icon, {
        file: _unref(backSVG)
      }, null, 8, ["file"])]), _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.".concat(_unref(TabName)))), 1)])) : _createCommentVNode("", true), !_unref(currentTab) || _unref(isUniFrameWork) && _unref(currentTab) != 'admin' ? (_openBlock(), _createElementBlock("main", _hoisted_3, [_createVNode(ManageName, {
        "class": "space-top",
        isAuthor: _unref(isAuthor),
        data: _unref(_currentGroup),
        onUpdate: updateProfile
      }, null, 8, ["isAuthor", "data"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("header", {
        "class": "userInfo-header",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return setCurrentTab('member');
        })
      }, [_createElementVNode("label", _hoisted_5, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u6210\u5458")), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_unref(_currentGroup).memberCount || _unref(groupMemberList).length) + " " + _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u4EBA")), 1), _createVNode(Icon, {
        file: _unref(rightIcon)
      }, null, 8, ["file"])])]), _createElementVNode("ol", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupMemberList).slice(0, _unref(showUserNum)), function (item, index) {
        return _openBlock(), _createElementBlock("dl", {
          "class": "userInfo-list-item",
          key: index
        }, [_createElementVNode("dt", {
          "class": "userInfo-list-item-main",
          onClick: function onClick($event) {
            return handleMemberProfileShow(item);
          }
        }, [_createElementVNode("img", {
          "class": "avatar",
          src: item.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
          onerror: "this.onerror=null;this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
        }, null, 8, _hoisted_10)], 8, _hoisted_9), _createElementVNode("dd", _hoisted_11, _toDisplayString(item.nick || item.userID), 1)]);
      }), 128)), _unref(isShowAddMember) ? (_openBlock(), _createElementBlock("dl", _hoisted_12, [_createElementVNode("dt", {
        "class": "avatar",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return toggleMask('add');
        })
      }, "+")])) : _createCommentVNode("", true), _unref(currentSelfRole) === 'Owner' ? (_openBlock(), _createElementBlock("dl", _hoisted_13, [_createElementVNode("dt", {
        "class": "avatar",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return toggleMask('remove');
        })
      }, "-")])) : _createCommentVNode("", true)])]), _createElementVNode("ul", {
        "class": "content list space-top",
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return editLableName.value = '';
        })
      }, [_createElementVNode("li", {
        "class": "list-item",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return setCurrentTab('notification');
        })
      }, [_createElementVNode("aside", _hoisted_14, [_createElementVNode("label", _hoisted_15, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u516C\u544A")), 1), _createElementVNode("article", _hoisted_16, _toDisplayString(_unref(_currentGroup).notification), 1)]), _createVNode(Icon, {
        file: _unref(rightIcon),
        "class": "end"
      }, null, 8, ["file"])]), _unref(isAdmin) && _unref(isSetMuteTime) ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        "class": "list-item",
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return setCurrentTab('admin');
        })
      }, [_createElementVNode("label", _hoisted_17, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u7BA1\u7406")), 1), _createVNode(Icon, {
        file: _unref(rightIcon)
      }, null, 8, ["file"])])) : _createCommentVNode("", true), _createElementVNode("li", _hoisted_18, [_createElementVNode("label", _hoisted_19, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4ID")), 1), _createElementVNode("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(_unref(currentGroupID)), 1)])]), _createElementVNode("li", _hoisted_22, [_createElementVNode("label", _hoisted_23, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u5934\u50CF")), 1), _createElementVNode("img", {
        "class": "avatar",
        src: _unref(_currentGroup).avatar || 'https://web.sdk.qcloud.com/im/demo/TUIkit/web/img/constomer.svg',
        onerror: "this.onerror=null;this.src='https://web.sdk.qcloud.com/im/demo/TUIkit/web/img/constomer.svg'"
      }, null, 8, _hoisted_24)]), _createElementVNode("li", _hoisted_25, [_createElementVNode("label", _hoisted_26, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u7C7B\u578B")), 1), _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.".concat(_unref(typeName)[_unref(_currentGroup).type]))), 1)]), _createElementVNode("li", _hoisted_28, [_createElementVNode("label", _hoisted_29, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u52A0\u7FA4\u65B9\u5F0F")), 1), _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.".concat(_unref(typeName)[_unref(_currentGroup).joinOption]))), 1)])]), _createElementVNode("ul", _hoisted_31, [_unref(currentSelfRole) === 'Owner' && _unref(groupMemberList).length > 1 ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        "class": "list-item",
        onClick: _cache[6] || (_cache[6] = _withModifiers(function ($event) {
          return toggleMask('changeOwner');
        }, ["stop"]))
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u8F6C\u8BA9\u7FA4\u7EC4")), 1)) : _createCommentVNode("", true), _unref(canIDissmissGroup) ? (_openBlock(), _createElementBlock("li", {
        key: 1,
        "class": "list-item",
        onClick: _cache[7] || (_cache[7] = _withModifiers(function ($event) {
          return dismissGroup(_unref(_currentGroup));
        }, ["stop"]))
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u89E3\u6563\u7FA4\u804A")), 1)) : (_openBlock(), _createElementBlock("li", {
        key: 2,
        "class": "list-item",
        onClick: _cache[8] || (_cache[8] = _withModifiers(function ($event) {
          return quitGroup(_unref(_currentGroup));
        }, ["stop"]))
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u9000\u51FA\u7FA4\u7EC4")), 1))])])) : _createCommentVNode("", true), _unref(currentTab) === 'member' ? (_openBlock(), _createBlock(ManageMember, {
        key: 2,
        self: _unref(_currentGroup).selfInfo,
        list: _unref(groupMemberList),
        total: ~~_unref(_currentGroup).memberCount,
        isShowDel: _unref(currentSelfRole) === 'Owner' && _unref(canDelMember),
        onMore: _cache[9] || (_cache[9] = function ($event) {
          return getMember('more');
        }),
        onDel: submit,
        onHandleMemberProfileShow: handleMemberProfileShow,
        onClose: _cache[10] || (_cache[10] = function ($event) {
          return setCurrentTab('');
        })
      }, null, 8, ["self", "list", "total", "isShowDel"])) : _createCommentVNode("", true), _unref(currentTab) === 'profile' ? (_openBlock(), _createBlock(ManageProfile, {
        key: 3,
        userInfo: _unref(currentMember),
        onClose: _cache[11] || (_cache[11] = function ($event) {
          return setCurrentTab('');
        })
      }, null, 8, ["userInfo"])) : _createCommentVNode("", true), _unref(currentTab) === 'notification' ? (_openBlock(), _createBlock(ManageNotification, {
        key: 4,
        isAuthor: _unref(isAuthor),
        data: _unref(_currentGroup),
        onUpdate: updateProfile,
        onClose: _cache[12] || (_cache[12] = function ($event) {
          return setCurrentTab('');
        })
      }, null, 8, ["isAuthor", "data"])) : _createCommentVNode("", true), _unref(currentTab) === 'admin' ? _withDirectives((_openBlock(), _createBlock(ManageAdmin, {
        key: 5,
        isSetMuteTime: _unref(isSetMuteTime),
        member: _unref(member),
        currentGroup: _unref(_currentGroup),
        onAddAdmin: _cache[13] || (_cache[13] = function ($event) {
          return toggleMask('addAdmin');
        }),
        onRemoveAdmin: _cache[14] || (_cache[14] = function ($event) {
          return toggleMask('removeAdmin');
        }),
        onSetAllMuteTime: setAllMuteTime,
        onAddMute: _cache[15] || (_cache[15] = function ($event) {
          return toggleMask('addMute');
        }),
        onRemoveMute: _cache[16] || (_cache[16] = function ($event) {
          return toggleMask('removeMute');
        }),
        onClose: _cache[17] || (_cache[17] = function ($event) {
          return setCurrentTab('');
        })
      }, null, 8, ["isSetMuteTime", "member", "currentGroup"])), [[_vShow, _unref(isAdmin)]]) : _createCommentVNode("", true), _createVNode(MaskLayer, {
        show: _unref(mask),
        "onUpdate:show": _cache[18] || (_cache[18] = function (e) {
          return mask.value = e;
        })
      }, {
        "default": _withCtx(function () {
          return [_createVNode(Transfer, {
            title: _unref(TUITranslateService).t("TUIGroup.".concat(_unref(transferTitle))),
            list: _unref(transferList),
            isSearch: _unref(isSearch),
            isRadio: _unref(isRadio),
            selectedList: _unref(selectedList),
            onSubmit: submit,
            onCancel: cancel,
            onSearch: handleSearchMember,
            isH5: !_unref(isPC)
          }, null, 8, ["title", "list", "isSearch", "isRadio", "selectedList", "isH5"])];
        }),
        _: 1
      }, 8, ["show"]), _createVNode(Dialog, {
        "class": "deleted-dialog",
        title: _unref(TUITranslateService).t("TUIGroup.\u5220\u9664\u6210\u5458"),
        show: _unref(delDialogShow),
        isH5: !_unref(isPC),
        center: true,
        isHeaderShow: _unref(isPC),
        onSubmit: _cache[19] || (_cache[19] = function ($event) {
          return handleManage(_unref(deletedUserList), 'remove');
        }),
        "onUpdate:show": _cache[20] || (_cache[20] = function (e) {
          return delDialogShow.value = e;
        })
      }, {
        "default": _withCtx(function () {
          return [_unref(deletedUserList).length === 1 ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u786E\u5B9A\u4ECE\u7FA4\u804A\u4E2D\u5220\u9664\u8BE5\u6210\u5458\uFF1F")), 1)) : _createCommentVNode("", true), _unref(deletedUserList).length > 1 ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u786E\u5B9A\u4ECE\u7FA4\u804A\u4E2D\u5220\u9664\u6240\u9009\u6210\u5458\uFF1F")), 1)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["title", "show", "isH5", "isHeaderShow"])], 512);
    };
  }
});